/* =========================
 * Helpers de fecha
 * ========================= */

export function startOfDay(d: Date | string | number): Date {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

export function addDays(d: Date, n: number): Date {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}

export function isSameDay(a: Date, b: Date): boolean {
  const x = startOfDay(a).getTime();
  const y = startOfDay(b).getTime();
  return x === y;
}

export function formatISODate(d: Date): string {
  const x = startOfDay(d);
  const yyyy = x.getFullYear();
  const mm = String(x.getMonth() + 1).padStart(2, '0');
  const dd = String(x.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function formatDayLabel(
  d: Date,
  locale: string = 'es-CO'
): string {
  return new Intl.DateTimeFormat(locale, {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
  }).format(d);
}

export function formatDayNumber(
  d: Date,
  locale: string = 'es-CO'
): string {
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
  }).format(d);
}

export function buildVisibleDates(
  startDate: Date,
  daysVisible: number
): Date[] {
  const arr: Date[] = [];
  for (let i = 0; i < daysVisible; i++) {
    arr.push(addDays(startDate, i));
  }
  return arr;
}
